import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight, Building2, Briefcase, Home, HardHat, ClipboardCheck, Users } from 'lucide-react';
import { services } from '../data/mock';

const ServicesCarousel = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: 'start',
    slidesToScroll: 1
  });

  const iconMap = {
    Building2,
    Briefcase,
    Home,
    HardHat,
    ClipboardCheck,
    Users
  };

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="services-carousel">
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon] || Building2;
            return (
              <div key={service.id} className="embla__slide-service">
                <div className="service-slide-card">
                  <div className="service-slide-icon-wrapper">
                    <IconComponent className="service-slide-icon" size={48} />
                  </div>
                  <h3 className="service-slide-title">{service.title}</h3>
                  <p className="service-slide-description">{service.description}</p>
                  <ul className="service-slide-features">
                    {service.features.map((feature, idx) =>
                    <li key={idx} className="!text-[#0F0000]">{feature}</li>
                    )}
                  </ul>
                </div>
              </div>);

          })}
        </div>
      </div>

      <button className="embla__prev" onClick={scrollPrev} aria-label="Previous">
        <ChevronLeft size={32} />
      </button>
      <button className="embla__next" onClick={scrollNext} aria-label="Next">
        <ChevronRight size={32} />
      </button>
    </div>);

};

export default ServicesCarousel;